module.exports = __webpack_public_path__ + "static/media/loxone-image-section-four-1.ab13aeb3.png";